import { type AnyAction, combineReducers } from 'redux';

import type { Notification } from 'js/src/client';
import {
    setHasUnreadNotifications,
    setLoadingNotifications,
    setNotificationsIsEmpty,
    storeNotifications,
} from 'js/src/data/notifications/notification-actions';
import { NotificationUiState } from 'js/src/data/notifications/notification-types';
import StoreORM from 'js/src/data/store-orm';

export function notifications_list(
    state = StoreORM.newFromIdPrefix<Notification>('notifications').data,
    action: AnyAction,
) {
    // clear first then store the new notifications
    if (storeNotifications.match(action)) {
        const orm = new StoreORM<Notification>(state);
        orm.delete(orm.getAllIds());
        action.payload.notifications_list.forEach((notification) =>
            orm.pushItem(notification, 'id'),
        );
        return orm.data;
    }
    return state;
}

export function has_unread(state = false, action: AnyAction): boolean {
    if (setHasUnreadNotifications.match(action)) {
        return action.payload.hasUnread;
    } else if (storeNotifications.match(action)) {
        const count = action.payload.notifications_list.filter(
            (notification) => notification.get('read_status') === false,
        ).size;
        return count > 0;
    }

    return state;
}

export function uiState(state = NotificationUiState.EMPTY, action: AnyAction): NotificationUiState {
    if (setLoadingNotifications.match(action)) {
        const {
            payload: { isLoading },
        } = action;
        return isLoading ? NotificationUiState.LOADING : NotificationUiState.SHOWING;
    } else if (setNotificationsIsEmpty.match(action)) {
        const {
            payload: { isEmpty },
        } = action;
        return isEmpty ? NotificationUiState.EMPTY : NotificationUiState.SHOWING;
    }

    // default
    return state;
}

export const notifications = combineReducers({
    notifications_list,
    uiState,
    has_unread,
});

export type NotificationsState = ReturnType<typeof notifications>;
